import React, { Component, Fragment } from 'react';
import { Alert } from 'reactstrap';

export class StatusBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            message: null,
            isError: false,
            hideMessage: false
        };
    }
    

    render() {
        //if (this.props.onTimeout) setTimeout(1000, this.props.onTimeout())
        //setTimeout(1000, (() => this.props.onTimeout()))
        return (
            <Fragment>
                {!this.state.hideMessage 
                    ? <div>{
                        this.props.message !== undefined && this.props.message !== null && this.props.message !== ''
                            ? <Alert color={this.props.isError
                                ? 'danger'
                                : 'warning'}>
                                {this.props.message}
                            </Alert>
                            : null
                    }
                    </div>
                    : null}
            </Fragment>);
    }
}